// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__NOuz8","messages":"Chat_messages__2sO2c","dateDivider":"Chat_dateDivider__uuPln"};